export const BrakeSystemKeys = {
  brakeTB: 'brakeTB',
  brakeMB: 'brakeMB',
  edBarRequest: 'edBarRequest',
  sHmiPbIsolationApprove: 'sHmiPbIsolationApprove',
  validBrakeTestTimeExpired: 'validBrakeTestTimeExpired',
  validBrakeTestTimeHalfExpired: 'validBrakeTestTimeHalfExpired',
  sifaIsolation: 'sifaIsolation',
  parkBrakeIsolation: 'parkBrakeIsolation',
  majorBrPark: 'majorBrPark',
  brakeCommunicationError: 'brakeCommunicationError',
  tkysBrakeCommunicationError: 'tkysBrakeCommunicationError',
  mrpPress: 'mrpPress',
  bpPress: 'bpPress',
  SPBEmerRelConf: 'SPBEmerRelConf',
  isolationCockParkingBrakeIsolated1: 'isolationCockParkingBrakeIsolated1',
  isolationCockParkingBrakeIsolated2: 'isolationCockParkingBrakeIsolated2',
  pressureGovernorPBReleased: 'pressureGovernorPBReleased',
  pressureGovernorDetectionEmergencyBrake: 'pressureGovernorDetectionEmergencyBrake',
  SIFA1PositionHandle: 'SIFA1PositionHandle',
  SIFA1TractionControl: 'SIFA1TractionControl',
  SIFA2PositionHandle: 'SIFA2PositionHandle',
  SIFA2TractionControl: 'SIFA2TractionControl',
  isolationCockSanding: 'isolationCockSanding',
  isolationCockBPToMRPBypass: 'isolationCockBPToMRPBypass',
  isolationCockBPTest: 'isolationCockBPTest',
  isolationCock1BPControl: 'isolationCock1BPControl',
  isolationCock2BPControl: 'isolationCock2BPControl',
  pressureGovernorIndirectBrakeControl: 'pressureGovernorIndirectBrakeControl',
  cPressTB: 'cPressTB',
  cPressMB: 'cPressMB',
  isolationCockPneumaticBrakeIsolatedTB: 'isolationCockPneumaticBrakeIsolatedTB',
  isolationCockPneumaticBrakeIsolatedMB: 'isolationCockPneumaticBrakeIsolatedMB',
  isolationCockDirectBrakeIsolatedTB: 'isolationCockDirectBrakeIsolatedTB',
  isolationCockDirectBrakeIsolatedMB: 'isolationCockDirectBrakeIsolatedMB',
  pressureGovernorBrakeUnitAppliedReleased: 'pressureGovernorBrakeUnitAppliedReleased',
  pressureGovernorBrakeUnitAppliedReleasedTB: 'pressureGovernorBrakeUnitAppliedReleasedTB',
  pressureGovernorBrakeUnitAppliedReleasedMB: 'pressureGovernorBrakeUnitAppliedReleasedMB',
  EBCU_C_FCTOK: 'EBCU_C_FCTOK',
  diaWspTestAborted: 'diaWspTestAborted',
  sBCUEblOpenPb: 'sBCUEblOpenPb',
  diaMvbErrorTcu: 'diaMvbErrorTcu',
  diaMvbErrorBcu: 'diaMvbErrorBcu',
  diaMvbErrorVcu: 'diaMvbErrorVcu',
  group44CBProtection: 'group44CBProtection',
  compressorMVCBProtection: 'compressorMVCBProtection',
  isolationCockAirSupply: 'isolationCockAirSupply',
  diaSandingDisturbed: 'diaSandingDisturbed',
  diaPSensorMrp: 'diaPSensorMrp',
  diaPSensorBp: 'diaPSensorBp',
  relayEmergencyLoop: 'relayEmergencyLoop',
  diaCPressHoseBrake: 'diaCPressHoseBrake',
  diaCPressHoseBrakeTB: 'diaCPressHoseBrakeTB',
  diaCPressHoseBrakeMB: 'diaCPressHoseBrakeMB',
  diaBrakeNotReleased: 'diaBrakeNotReleased',
  diaBrakeNotReleasedTB: 'diaBrakeNotReleasedTB',
  diaBrakeNotReleasedMB: 'diaBrakeNotReleasedMB',
  diaBrakeNotApplied: 'diaBrakeNotApplied',
  diaBrakeNotAppliedTB: 'diaBrakeNotAppliedTB',
  diaBrakeNotAppliedMB: 'diaBrakeNotAppliedMB',
  diaDirectBrakeDist: 'diaDirectBrakeDist',
  diaDirectBrakeDistTB: 'diaDirectBrakeDistTB',
  diaDirectBrakeDistMB: 'diaDirectBrakeDistMB',
  pressureGovernorPressureAirSuspension: 'pressureGovernorPressureAirSuspension',
  pressureGovernorPressureAirSuspensionTB: 'pressureGovernorPressureAirSuspensionTB',
  pressureGovernorPressureAirSuspensionMB: 'pressureGovernorPressureAirSuspensionMB',
  diaAirSuspPressInvalid: 'diaAirSuspPressInvalid',
  diaAirSuspPressInvalidTB: 'diaAirSuspPressInvalidTB',
  diaAirSuspPressInvalidMB: 'diaAirSuspPressInvalidMB',
  diaWspFailure: 'diaWspFailure',
  diaWspFailureTB: 'diaWspFailureTB',
  diaWspFailureMB: 'diaWspFailureMB'
} as const;
